<template>
  <section class="recruiters-section">
    <div class="container mx-auto px-6">
      <div class="flex flex-wrap justify-center text-center mb-10">
        <div class="w-full lg:w-6/12 px-4">
          <h2 class="text-4xl font-semibold text-white">Programmes Run by the Institute</h2>
        </div>
      </div>
      <div class="container mx-auto overflow-x-auto mb-2 rounded-lg shadow-lg">
        <table class="w-full">
          <thead class="bg-gray-200 ">
          <tr>
            <th scope="col" rowspan="2">
              #
            </th>
            <th scope="col" rowspan="2">
              Name of Programme
            </th>
            <th class="text-center border-r-2 border-gray-50" colspan="2">UG</th>
            <th class="text-center" colspan="3">PG</th>
          </tr>
          <tr>
            <th>Intake</th>
            <th class="border-r-2 border-gray-50">Choice Code</th>
            <th>Specialization</th>
            <th>Intake</th>
            <th>Choice Code</th>
          </tr>
          </thead>
          <tbody>
          <tr class="bg-white border-b hover:bg-gray-100">
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">1
            </td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">
              Computer Engineering
            </td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">60</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512424510</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Computer Engineering</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">18</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512424510</td>
          </tr>
          <tr class="bg-white border-b hover:bg-gray-100">
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">2</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">
              Information Technology
            </td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">60</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512424610</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">-</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">-</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">-</td>
          </tr>
          <tr class="bg-white border-b hover:bg-gray-100">
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">3</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">
              Civil Engineering
            </td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">60</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512419110</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Structural Engineering</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">24</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512421210</td>
          </tr>
          <tr class="bg-white border-b hover:bg-gray-100">
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">4</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">
              Mechanical Engineering
            </td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">120</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512461210</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Heat Power Engineering</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">18</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512460110</td>
          </tr>
          <tr class="bg-white border-b hover:bg-gray-100">
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">5</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">
              Electrical Engineering
            </td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">180</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512429310</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Power Systems</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">24</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512490110</td>
          </tr>
          <tr class="bg-white border-b hover:bg-gray-100">
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">6</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">
              MBA
            </td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">-</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">-</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">All</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">60</td>
            <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">512410110</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Programmes"
}
</script>

<style scoped>

</style>
